import { type Nullable, type AbstractEngine, type EffectWrapperCreationOptions } from "core/index";
import { EffectWrapper } from "../Materials/effectRenderer";
import { EngineStore } from "../Engines/engineStore";

/**
 * @internal
 */
export class ThinBloomMergePostProcess extends EffectWrapper {
    public static readonly FragmentUrl = "bloomMerge";

    public static readonly Uniforms = ["bloomWeight"];

    public static readonly Samplers = ["bloomBlur"];

    protected override _gatherImports(useWebGPU: boolean, list: Promise<any>[]) {
        if (useWebGPU) {
            this._webGPUReady = true;
            list.push(import("../ShadersWGSL/bloomMerge.fragment"));
        } else {
            list.push(import("../Shaders/bloomMerge.fragment"));
        }
    }

    constructor(name: string, engine: Nullable<AbstractEngine> = null, options?: EffectWrapperCreationOptions) {
        super({
            ...options,
            name,
            engine: engine || EngineStore.LastCreatedEngine!,
            useShaderStore: true,
            useAsPostProcess: true,
            fragmentShader: ThinBloomMergePostProcess.FragmentUrl,
            uniforms: ThinBloomMergePostProcess.Uniforms,
            samplers: ThinBloomMergePostProcess.Samplers,
        });
    }

    /** Weight of the bloom to be added to the original input. */
    public weight = 1;

    public override bind(noDefaultBindings = false) {
        super.bind(noDefaultBindings);
        this._drawWrapper.effect!.setFloat("bloomWeight", this.weight);
    }
}
